import { ApplicantGroupType } from '@exam-center/graphql';

const applicantGroupTypeLabels: Record<ApplicantGroupType, string> = {
  [ApplicantGroupType.Bank]: 'ธนาคาร',
  [ApplicantGroupType.InsuranceCompany]: 'บริษัทประกัน',
  [ApplicantGroupType.SecuritiesCompany]: 'บริษัทหลักทรัพย์',
  [ApplicantGroupType.ProjectFree]: 'โครงการ (Free)',
  [ApplicantGroupType.ProjectCharge]: 'โครงการ (Charge)',
  [ApplicantGroupType.Student]: 'นักศึกษา',
  [ApplicantGroupType.Others]: 'อื่น ๆ',
};

export function getApplicantLabelAndValue(type: ApplicantGroupType | null) {
  if (!type) return undefined;

  return {
    label: applicantGroupTypeLabels[type],
    value: type,
  };
}
